import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddTicketPageRoutingModule } from './add-ticket-routing.module';

import { AddTicketPage } from './add-ticket.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    AddTicketPageRoutingModule
  ],
  declarations: [AddTicketPage]
})
export class AddTicketPageModule {}
